module.exports = __webpack_public_path__ + "img/care_guide_1.b82aec1a.png";